module.exports = __webpack_public_path__ + "static/iso-f60c808187fb9af5bff89f57d87e9ffb.png";